import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Sidebar from "./components/Sidebar";
import Jobs from "./components/Jobs/Jobs";
import Form from "./components/Form";

function App() {
  return (
    <Router>
      <Layout>
        <Sidebar />
        <Routes>
          <Route path="/" element={<Navigate replace to="/jobs" />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/jobs/new" element={<Form />} />
          <Route path="/jobs/edit/:jobId" element={<Form />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
